import { useCallback, useState } from "react";
import BankHistory from "./BankHistory";
import BankPurchase from "./BankPurchase";
import { useEffect } from "react";
import { api } from "../../utils/apiHandler";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";

const Bank = ({ setShowBankPopup, getUserData }) => {
  const [activeTab, setActiveTab] = useState("purchase");
  const [packages, setPackages] = useState([]);
  const [grantPackages, setGrantPackages] = useState([]);
  const [bankHistory, setBankHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [packagesLoaded, setPackagesLoaded] = useState(false);
  const { t } = useTranslation();

  const fetchPackages = useCallback(async () => {
    if (packagesLoaded) {
      return;
    }

    try {
      setIsLoading(true);
      const res = await api.get(`/packages`);
      const grantRes = await api.get(`/packages?grant=true`);
      const historyRes = await api.get("/bank_histories");
      setBankHistory(historyRes.data);
      setPackages(res.data);
      setGrantPackages(grantRes.data);
      setPackagesLoaded(true);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [packagesLoaded]);

  useEffect(() => {
    fetchPackages();
  }, [fetchPackages]);

  return (
    <div
      onClick={e => e.stopPropagation()}
      className={`relative w-full bg-white85 max-w-[786px] border-2 border-[#00000020] rounded-t-[10px] transition-transform duration-700 z-40  h-[80vh] `}
    >
      <div
        className="absolute left-1/2 -translate-x-1/2 -top-6 -translate-y-1/2"
        onClick={() => setShowBankPopup(false)}
      >
        <img src="/icons/Sangati/cancel.svg" alt="" className="scale-90" />
      </div>
      <div className="p-2 text-center text-20 font-bold flex items-center justify-center gap-3">
        <div className={`w-[20px] h-[20px] bg-[#C83126] border-2 border-sangati-green rounded-full transition-all ease-in-out duration-700`}></div>
        <span className="uppercase">{t("bank")}</span>
        <div className={`w-[20px] h-[20px] bg-[#C83126] border-2 border-sangati-green rounded-full transition-all ease-in-out duration-700`}></div>
      </div>
      <div className="flex h-full">
        <div className="w-[80px] border-r border-[#93938D] flex flex-col items-center my-2 gap-6">
          {/* Purchase Tab */}
          <div className="relative w-full flex justify-center">
            {activeTab === "purchase" && (
              <div className="absolute -right-[2px] top-0 h-full w-[5px] bg-sangati-green rounded-md"></div>
            )}
            <div
              className={`flex flex-col items-center cursor-pointer ${
                activeTab === "purchase"
                  ? "text-sangati-green"
                  : "text-[#93938D] drop-shadow-xl"
              }`}
              onClick={() => setActiveTab("purchase")}
            >
              {activeTab === "purchase" ? (
                <img
                  src="/icons/cartactive.svg"
                  alt="purchase"
                  className="size-[54px]"
                />
              ) : (
                <img
                  src="/icons/purchase.svg"
                  alt="purchase"
                  className="size-[54px]"
                />
              )}
              <span className="text-[14px]">{t("purchase")}</span>
            </div>
          </div>

          {/* History Tab */}
          <div className="relative w-full flex justify-center">
            {activeTab === "history" && (
              <div className="absolute -right-[2px] top-0 h-full w-[5px] bg-sangati-green rounded-md"></div>
            )}
            <div
              className={`flex flex-col items-center cursor-pointer ${
                activeTab === "history"
                  ? "text-sangati-green"
                  : "text-[#93938D] drop-shadow-xl"
              }`}
              onClick={() => setActiveTab("history")}
            >
              {activeTab === "history" ? (
                <img
                  src="/icons/historyactive.svg"
                  alt="history"
                  className="size-[46px]"
                />
              ) : (
                <img
                  src="/icons/history.svg"
                  alt="history"
                  className="size-[46px]"
                />
              )}
              <span className="text-[14px]">{t("history")}</span>
            </div>
          </div>
        </div>

        {/* Main Content */}
        {!isLoading ? (
          <div className="flex-1 relative p-4 overflow-y-scroll pb-[60px]">
            {activeTab === "purchase" && (
              <BankPurchase
                packages={packages}
                grantPackages={grantPackages}
                setShowBankPopup={setShowBankPopup}
                getUserData={getUserData}
              />
            )}
            {activeTab === "history" && <BankHistory history={bankHistory} />}
          </div>
        ) : (
          <div className="flex-1 relative p-4 overflow-y-scroll pb-[60px]">
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

export default Bank;
